import { ApiEndpoints } from "./apiEndpoints";
import { fetchData } from "./apiHelpers";
import { ContactWithReciprocal } from "./relationship.type";

export const getInviteDetailsBySlug = async (
  slug: string
): Promise<ContactWithReciprocal> => {
  try {
    const route = ApiEndpoints.accessRequest + `/slug/` + slug;

    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    const inviteDetails = await fetchData<ContactWithReciprocal>(
      route,
      options
    );
    return inviteDetails;
  } catch (error) {
    console.error("Error getting access request by slug:", error);
    throw error;
  }
};

export const handleGrantAccess = async (slug: string): Promise<void> => {
  try {
    const route = ApiEndpoints.accessRequest + `/grant/` + slug;

    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    await fetchData<void>(route, options);
  } catch (error) {
    console.error("Error granting access:", error);
    throw error;
  }
};

export const handleNewUserSignup = async ({ slug }: { slug: string }) => {
  try {
    const route = ApiEndpoints.accessRequest + "/signup";

    const options = {
      method: "POST",
      body: JSON.stringify({ slug }),
      headers: {
        "Content-Type": "application/json",
      },
    };

    const newUser = await fetchData(route, options);

    return newUser;
  } catch (err) {
    console.error("Error handling new user signup:", err);
    throw err;
  }
};
